<template>
  <div
    class="word-mark-container"
    ref="canvas-container"
    style="position:relative;"
  >
    <!-- 绘画、擦除选择 -->
    <!-- <div style="width:4.4rem;position:absolute;bottom:4rem;right:8rem">
      <div v-if="action_type == 'draw'" style="margin-bottom:1rem;">
        <div
          style="text-align:center;font-size:0.9rem;color:#ffffff;margin-bottom:0.5rem;"
        >
          画笔颜色
        </div>
        <div class="color-selector">
          <div
            v-for="(item, index) in colorList"
            :key="index"
            class="color-item"
            :style="{ background: item.color }"
            :class="{ 'color-selected': currentColor === item.color }"
            @click="selectColor(item.color)"
            :title="item.name"
          ></div>
        </div>
      </div>
      <div
        style="position:relative;cursor: pointer;"
        @click="setCanvasType('draw')"
      >
        <img src="../assets/mark_pencil.png" style="width:100%" />
        <img
          v-if="action_type == 'draw'"
          src="../assets/icon_selected.png"
          style="width:1.8rem;position:absolute;bottom:0;right:0"
        />
      </div>
      <div
        style="position:relative;margin-top:1rem;cursor: pointer;"
        @click="setCanvasType('eraser')"
      >
        <img src="../assets/mark_eraser.png" style="width:100%" />
        <img
          v-if="action_type == 'eraser'"
          src="../assets/icon_selected.png"
          style="width:1.8rem;position:absolute;bottom:0;right:0"
        />
      </div>
    </div> -->
    <!-- canvas -->
    <div class="action-container">
      <div class="pen-container">
        <div class="color-selector">
          <div
            v-for="(item, index) in colorList"
            :key="index"
            class="color-item"
            :style="{ background: item.color }"
            :class="{ 'color-selected': currentColor === item.color }"
            @click="selectColor(item.color)"
            :title="item.name"
          ></div>
        </div>
        <div @click="setCanvasType('draw')" class="pen-container-item">
          <img
            class="pen-icon"
            src="../assets/icon-pen.png"
            style="width:100%"
          />
          <img
            v-if="action_type == 'draw'"
            src="../assets/icon_selected.png"
            style="width:1.8rem;position:absolute;bottom:0;right:0;z-index: 10;"
          />
        </div>
      </div>

      <div @click="setCanvasType('eraser')" class="eraser-container">
        <div class="eraser-container-item">
          <img class="eraser-icon" src="../assets/icon-eraser.png" />
          <img
            v-if="action_type == 'eraser'"
            src="../assets/icon_selected.png"
            style="width:1.8rem;height:1.8rem;position:absolute;bottom:0;right:0"
          />
        </div>
      </div>
    </div>
    <canvas
      class="myCanvas"
      ref="task-canvas"
      :width="canvasWidth"
      :height="canvasHeight"
      :style="
        'background:url(\'' + poster + '\') no-repeat;background-size:100% 100%'
      "
    ></canvas>
  </div>
</template>

<script>
export default {
  name: "WordMark",
  props: {
    poster: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      action_type: "draw",
      canvasWidth: 0,
      canvasHeight: 0,
      canvas: null,
      ctx: null,
      currentColor: "#ff0000", // 当前选中的颜色，默认红色
      colorList: [
        { color: "#ff0000", name: "红色" },
        { color: "#00ff00", name: "绿色" },
        { color: "#0000ff", name: "蓝色" },
        { color: "#ffff00", name: "黄色" },
        { color: "#000000", name: "黑色" },
      ], // 可选颜色列表
    };
  },
  mounted() {
    let baseFontSize = getComputedStyle(window.document.documentElement)[
      "font-size"
    ].replace("px", "");
    this.canvasWidth = 36 * baseFontSize;
    this.canvasHeight = 36 * baseFontSize;

    this.action_type = "draw";
    this.currentColor = "#ff0000"; // 重置为默认颜色

    //做宽高自适应
    let picObj = document.createElement("img");
    picObj.src = this.poster;
    picObj.onload = () => {
      this.canvasHeight = this.canvasWidth * (picObj.height / picObj.width);
    };

    this.$nextTick(() => {
      if (!this.canvas) {
        this.canvas = this.$refs["task-canvas"];
        this.canvas.addEventListener(
          "mousedown",
          this.startEventHandler,
          false
        );
        this.canvas.addEventListener(
          "touchstart",
          this.startEventHandler,
          false
        );
      }
      if (!this.ctx) {
        this.ctx = this.canvas.getContext("2d");
      } else {
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      }
    });
  },
  beforeDestroy() {
    this.canvas = null;
    this.ctx = null;
  },
  methods: {
    setCanvasType(type) {
      this.action_type = type;
    },
    selectColor(color) {
      if (this.action_type != "draw") {
        this.action_type = "draw";
      }

      this.currentColor = color;
    },
    startEventHandler(ev) {
      let coverPos = this.canvas.getBoundingClientRect();
      var x, y;
      if (ev.touches && ev.touches.length > 0) {
        x = ev.touches[0].clientX - coverPos.left;
        y = ev.touches[0].clientY - coverPos.top;
      } else {
        x = ev.clientX - coverPos.left;
        y = ev.clientY - coverPos.top;
      }
      if (this.action_type == "draw") {
        this.ctx.beginPath();
      }
      this.ctx.moveTo(x, y);
      this.canvas.addEventListener("mousemove", this.moveEventHandler, false);
      this.canvas.addEventListener("touchmove", this.moveEventHandler, false);
      this.$refs["canvas-container"].addEventListener(
        "mouseup",
        this.endEventHandler,
        false
      );
      this.$refs["canvas-container"].addEventListener(
        "touchend",
        this.endEventHandler,
        false
      );
    },
    erase(ev) {
      let coverPos = this.canvas.getBoundingClientRect();
      var targetX, targetY;
      if (ev.touches && ev.touches.length > 0) {
        targetX = ev.touches[0].clientX - coverPos.left;
        targetY = ev.touches[0].clientY - coverPos.top;
      } else {
        targetX = ev.clientX - coverPos.left;
        targetY = ev.clientY - coverPos.top;
      }
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.fillStyle = "#ffffff";
      this.ctx.arc(targetX, targetY, 20, 0, Math.PI * 2, true);
      this.ctx.clip();
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      this.ctx.restore();
    },
    draw(ev) {
      let coverPos = this.canvas.getBoundingClientRect();
      var targetX, targetY;
      if (ev.touches && ev.touches.length > 0) {
        targetX = ev.touches[0].clientX - coverPos.left;
        targetY = ev.touches[0].clientY - coverPos.top;
      } else {
        targetX = ev.clientX - coverPos.left;
        targetY = ev.clientY - coverPos.top;
      }
      this.ctx.lineWidth = 1;
      this.ctx.lineCap = "round";
      this.ctx.lineJoin = "round";
      this.ctx.shadowBlur = 1;
      this.ctx.shadowColor = this.currentColor;
      this.ctx.strokeStyle = this.currentColor;
      this.ctx.lineTo(targetX, targetY);
      this.ctx.stroke();
    },
    moveEventHandler(ev) {
      if (this.action_type == "draw") {
        this.draw(ev);
      } else {
        this.erase(ev);
      }
    },
    endEventHandler() {
      this.canvas.removeEventListener(
        "mousemove",
        this.moveEventHandler,
        false
      );
      this.canvas.removeEventListener(
        "touchmove",
        this.moveEventHandler,
        false
      );
      this.$refs["canvas-container"].removeEventListener(
        "mouseup",
        this.endEventHandler,
        false
      );
      this.$refs["canvas-container"].removeEventListener(
        "touchend",
        this.endEventHandler,
        false
      );
    },
    doCancle() {
      if (typeof this.cancle == "function") {
        this.cancle();
      }
      this.hide();
    },
    doConfirm() {
      if (typeof this.success == "function") {
        this.success();
      }
      this.hide();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.word-mark-container {
  width: 60rem;
  height: 40rem;
  background: #e8efff;
  border-radius: 0.92rem 0.92rem 0.92rem 0.92rem;
  position: relative;
}
.myCanvas {
  border-radius: 0.92rem;
  background-size: 100% 100% !important;
  background-repeat: no-repeat;
  margin-left: 4rem;
  margin-top: 2rem;
}

.action-container {
  position: absolute;
  bottom: 2rem;
  right: 7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.48rem;
}

.pen-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  padding: 0.96rem 0.48rem;
  border-radius: 3.63rem 3.63rem 3.63rem 3.63rem;
}

.pen-container-item {
  position: relative;
}

.pen-icon {
  width: 4.04rem;
  height: 4.04rem;
}

.color-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.color-item {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #ffffff;
  transition: all 0.2s;
  position: relative;
}

.color-item.color-selected {
  width: 1.6rem;
  height: 1.6rem;
}

.color-item::after {
  content: "";
  display: block;
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid #ffffff;
  box-sizing: border-box;
}

.eraser-container {
  position: relative;
}

.eraser-container-item {
  position: relative;
}

.eraser-icon {
  width: 4.6rem;
  height: 4.6rem;
}

.cancleBtn {
  font-size: 1.4rem;
  color: #ffffff;
  height: 3.2rem;
  width: 9.4rem;
  text-align: center;
  line-height: 3.2rem;
  border-radius: 1.6rem;
  background: linear-gradient(to right, #ffa143, #ffc11d);
}

.confirmBtn {
  font-size: 1.4rem;
  color: #ffffff;
  height: 3.2rem;
  width: 9.4rem;
  text-align: center;
  line-height: 3.2rem;
  border-radius: 1.6rem;
  background: #2a9bff;
}

.cancleBtn:hover {
  background: linear-gradient(to right, #f38b22, #f38b22);
}

.confirmBtn:hover {
  background: #158ffa;
}
</style>
